import React from 'react';

const EmDash = () => (<>&mdash;</>);

export default EmDash;
